import { createOrganizationReference } from '../../firebase/firebaseAPICalls/FirebaseAPICallsOrganization';
import { createTeamReference } from '../../firebase/firebaseAPICalls/FirebaseAPICallsTeam';
import { getCurrentDateTime } from '../DateTime';
import { SportsType } from '../enums/SportsType';
import { createArticleReference } from '../../firebase/firebaseAPICalls/FirebaseAPICallsArticle';
import { ArticleObject } from '../interface/ArticleInterface';
import { TagType } from '../enums/TagType';
import { createGalleryReference } from '../../firebase/firebaseAPICalls/FirebaseAPICallsGallery';
import { createSeasonReference } from '../../firebase/firebaseAPICalls/FirebaseAPICallsSeason';
import { createGameReference } from '../../firebase/firebaseAPICalls/FirebaseAPICallsGame';
import { createGameTitle, demoGameFeatureImage, demoGameStatus } from './game/GameDemo';
import { demoOpponentName } from './OpponentDemo';
import { createEventReference } from '../../firebase/firebaseAPICalls/FirebaseAPICallsEvent';
import { demoEventFeatureImage, demoEventTitle } from './EventDemo';

export const demoArticleTitle = 'How we beat our rivals!!!';
export const demoArticleURL = '';
export const demoArticleAuthor = 'John Doe';
export const demoArticleContent = '<h2 style="text-align:center;"><span style="color: rgb(0,0,0);background-color: rgb(255,255,255);font-size: 14px;font-family: Open Sans", Arial, sans-serif;"><em>"Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit..."</em></span></h2><h2 style="text-align:center;"><span style="color: rgb(0,0,0);background-color: rgb(255,255,255);font-size: 12px;font-family: Open Sans", Arial, sans-serif;">"There is no one who loves pain itself, who seeks after it and wants to have it, simply because it is pain..."</span></h2><p><span style="color: rgb(0,0,0);background-color: rgb(255,255,255);font-size: 14px;font-family: Open Sans", Arial, sans-serif;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus aliquet eleifend facilisis. Nullam in nisi hendrerit, bibendum libero sed, vehicula lorem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquet sem non mi blandit, scelerisque tristique elit consectetur. Cras sit amet pulvinar orci, aliquam tempor ligula. Vivamus non ligula sit amet nulla consequat scelerisque ut at diam. Nam at dui ultricies lorem fermentum consequat. Mauris vitae odio varius, scelerisque ante vel, scelerisque massa. Praesent nec lorem id augue viverra efficitur. Integer a lobortis enim. Proin molestie, dui sit amet egestas gravida, nibh nisi faucibus sem, vel sollicitudin lorem urna nec neque. Pellentesque id faucibus magna, vitae vestibulum sapien.</span></p><p style="text-align:justify;"><span style="color: rgb(0,0,0);background-color: rgb(255,255,255);font-size: 14px;font-family: Open Sans", Arial, sans-serif;">Suspendisse dui dolor, tristique id urna ac, sollicitudin vehicula libero. Phasellus dapibus suscipit orci sed finibus. Maecenas sed mi sapien. Mauris sollicitudin metus velit. Aenean non tellus id metus vulputate finibus at ac neque. Suspendisse vulputate augue dapibus tristique commodo. In convallis maximus varius. Mauris vel velit hendrerit, feugiat lorem a, aliquet diam. Mauris placerat quam accumsan dui rhoncus, venenatis egestas libero imperdiet. Nullam nec sagittis turpis, at malesuada sapien. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</span></p><p style="text-align:justify;"><span style="color: rgb(0,0,0);background-color: rgb(255,255,255);font-size: 14px;font-family: Open Sans", Arial, sans-serif;">Donec diam leo, euismod sed quam id, hendrerit efficitur ligula. Proin et mollis ligula. Curabitur quis justo eu ligula tincidunt luctus. Ut ornare mattis efficitur. Nulla quis hendrerit sapien, vitae elementum metus. Donec ut velit eget elit mattis ornare a vitae ex. Integer eu tempus massa, eget pellentesque orci. Vivamus rhoncus, tellus quis condimentum tincidunt, dui augue ornare velit, vitae consectetur arcu libero ac ligula. Ut condimentum magna turpis, eu rhoncus erat rutrum non. Nulla vehicula augue non metus aliquam, et vulputate massa lobortis.</span></p><p style="text-align:justify;"><span style="color: rgb(0,0,0);background-color: rgb(255,255,255);font-size: 14px;font-family: Open Sans", Arial, sans-serif;">Suspendisse varius fermentum gravida. Vestibulum sit amet vulputate orci. Suspendisse non accumsan lorem, et sollicitudin dolor. In sit amet lacus et urna eleifend lacinia quis vitae nulla. Suspendisse accumsan pulvinar tempus. Praesent fermentum quis purus non dapibus. Mauris ut convallis justo, vitae fringilla lorem. Pellentesque sit amet ipsum elit. Phasellus pellentesque libero leo, et molestie metus sagittis a. Nulla facilisi. Pellentesque quis dolor a enim varius porta sed id nunc. Maecenas et justo mauris.</span></p><p style="text-align:justify;"><span style="color: rgb(0,0,0);background-color: rgb(255,255,255);font-size: 14px;font-family: Open Sans", Arial, sans-serif;">Curabitur magna diam, interdum quis nibh id, tincidunt pellentesque nulla. Vestibulum eu justo vitae erat venenatis varius et vitae ante. Fusce sed feugiat massa. Cras non pellentesque neque. Nulla facilisi. In finibus est dui, a condimentum quam condimentum at. Vestibulum lacinia euismod finibus. Vestibulum fringilla eros sed sapien vehicula, at placerat quam lacinia. Donec ultricies orci sed lorem vestibulum pulvinar. Mauris id gravida ipsum. Nam convallis, risus vel venenatis porta, justo est tincidunt nulla, in vehicula neque mi nec erat.</span><br></p>';
export const demoArticleNotes = '-Article was written on November 2019 about how we beat our rivals';

export const getDemoArticleTitle = (teamName: string) => {
    return `${teamName} partners with OptimX Sports`;
};

export const getDemoArticleAuthor = (teamName: string) => {
    return teamName;
};

export const getDemoArticleContent = (teamName: string) => {
    return `<p>The ${teamName} have partnered with OptimX Sports to provide the technological backbone for its official team website.</p>
    <p>The newly redesigned site offers a clean and modern design that is more user-friendly than ever before. Fans now can find the information they are looking for faster and easier, with plenty of opportunities for fan engagement.</p>
    <p>New upcoming events and results feature are also available for fans and players to stay informed with what is scheduled throughout the season as well as alumni engagement forms for past players to stay in touch with ${teamName}.</p>
    <p>OptimX Sports was launched earlier this year with the purpose of providing amateur sports teams with more modern-looking team websites at affordable pricing. The company is based in Chicago, IL and was founded by a former ACHA Hockey player who continues to lead the operations. OptimX Sports is trusted by some of the biggest programs, including Indiana University, Texas Christian University, Southern Methodist University, and many more collegiate teams. To make the deal sweeter, OptimX Sports is offering a full year free service subscription for the first month with each team that signs up. This includes the creation and management of a team’s athletic website. As a startup in the collegiate athletic web solutions space, OptimX Sports provides software and technology that powers team websites, roster creations, fan engagement, live stat records, and social media presence for its partners.</p>
    <p>For more information, please contact jon@optimxtechnologies.com or contact@optimxtechnologies.com. Additional information can be found online at<span>&nbsp;</span><a href="https://optimxsports.com/" target="_blank" style="word-break: break-all;">optimxsports.com</a>. Follow us on social media<span>&nbsp;</span><a href="https://www.instagram.com/optimxsports/" target="_blank" style="word-break: break-all;">@optimxsports</a>.</p>`;
};

export const getDemoArticleNotes = () => {
    return '-Article about our website partners';
};

export const demoArticleFeatureImage = (sportsType: SportsType) => {
    if (sportsType === SportsType.WOMENSICEHOCKEY || sportsType === SportsType.MENSICEHOCKEY) {
        return 'https://firebasestorage.googleapis.com/v0/b/optimx-sports.appspot.com/o/demo%2FdemoArticle%2FiceHockey%2FdemoFeatureImage%2FdemoFeatureImage2_1600x900.png?alt=media&token=a7e2c51e-f130-4edb-b61e-01ff8bdc8f7b';
    }
    if (sportsType === SportsType.WOMENSRUGBY || sportsType === SportsType.MENSRUGBY) {
        return 'https://firebasestorage.googleapis.com/v0/b/optimx-sports.appspot.com/o/demo%2FdemoArticle%2Frugby%2FdemoFeatureImage%2FdemoFeatureImage2_1600x900.png?alt=media&token=bc655f2f-e103-4794-a1f2-f27d0195cc2b';
    }
    if (sportsType === SportsType.WOMENSLACROSSE || sportsType === SportsType.MENSLACROSSE) {
        return 'https://firebasestorage.googleapis.com/v0/b/optimx-sports.appspot.com/o/demo%2FdemoArticle%2Flacrosse%2FdemoFeatureImage%2FdemoFeatureImage2_1600x900.png?alt=media&token=a7e2c51e-f130-4edb-b61e-01ff8bdc8f7b';
    }
    if (sportsType === SportsType.WOMENSBASEBALL || sportsType === SportsType.MENSBASEBALL) {
        return 'https://firebasestorage.googleapis.com/v0/b/optimx-sports.appspot.com/o/demo%2FdemoArticle%2Fbaseball%2FdemoFeatureImage%2FdemoFeatureImage2_1600x900.png?alt=media&token=a7e2c51e-f130-4edb-b61e-01ff8bdc8f7b';
    }
    return '';
};

export const createArticleTitleForGame = (gameTitle: string): string => {
    return gameTitle;
};
export const createArticleTitleForEvent = (eventTitle: string): string => {
    return eventTitle;
};

export const createDemoArticle = (organizationId: string, teamId: string, teamName: string, articleId: string, tagIds: string[], tagReferences: any[], tagTypes: TagType[], galleryId: string, sportsType: SportsType): ArticleObject => {
    const articleReference = createArticleReference(articleId);
    const galleryReference = createGalleryReference(galleryId);
    const teamReference = createTeamReference(teamId);
    const organizationReference = createOrganizationReference(organizationId);

    return {
        id: articleId,
        urlId: articleId,
        reference: articleReference,
        teamId,
        teamReference,
        organizationId,
        organizationReference,
        seasonId: '',
        seasonReference: null,
        gameId: '',
        gameReference: null,
        eventId: '',
        eventReference: null,
        practiceId: '',
        practiceReference: null,
        playerId: '',
        playerReference: null,
        coachId: '',
        coachReference: null,
        galleryId,
        galleryReference,
        title: getDemoArticleTitle(teamName),
        url: demoArticleURL,
        author: getDemoArticleAuthor(teamName),
        tagIds,
        tagReferences,
        tagTypes,
        content: getDemoArticleContent(teamName),
        mobileContent: '',
        sportsType,
        featureImage: demoArticleFeatureImage(sportsType),
        notes: getDemoArticleNotes(),
        published: true,
        timeOfArticle: getCurrentDateTime(),
        timeModified: getCurrentDateTime(),
        timeCreated: getCurrentDateTime(),
    };
};

export const createDemoGameArticle = (organizationId: string, teamId: string, articleId: string, tagIds: string[], tagReferences: any[], tagTypes: TagType[], seasonId: string, gameId: string, galleryId: string, sportsType: SportsType): ArticleObject => {
    const articleReference = createArticleReference(articleId);
    const seasonReference = createSeasonReference(teamId, seasonId);
    const gameReference = createGameReference(gameId);
    const galleryReference = createGalleryReference(galleryId);
    const teamReference = createTeamReference(teamId);
    const organizationReference = createOrganizationReference(organizationId);

    return {
        id: articleId,
        urlId: articleId,
        reference: articleReference,
        teamId,
        teamReference,
        organizationId,
        organizationReference,
        seasonId,
        seasonReference,
        gameId,
        gameReference,
        eventId: '',
        eventReference: null,
        practiceId: '',
        practiceReference: null,
        playerId: '',
        playerReference: null,
        coachId: '',
        coachReference: null,
        galleryId,
        galleryReference,
        title: createArticleTitleForGame(createGameTitle(demoOpponentName, demoGameStatus, new Date())),
        url: demoArticleURL,
        author: demoArticleAuthor,
        tagIds,
        tagReferences,
        tagTypes,
        content: demoArticleContent,
        mobileContent: '',
        sportsType,
        featureImage: demoGameFeatureImage(sportsType),
        notes: demoArticleNotes,
        published: true,
        timeOfArticle: getCurrentDateTime(),
        timeModified: getCurrentDateTime(),
        timeCreated: getCurrentDateTime(),
    };
};

export const createDemoEventArticle = (organizationId: string, teamId: string, articleId: string, tagIds: string[], tagReferences: any[], tagTypes: TagType[], seasonId: string, eventId: string, galleryId: string, sportsType: SportsType): ArticleObject => {
    const articleReference = createArticleReference(articleId);
    const seasonReference = createSeasonReference(teamId, seasonId);
    const eventReference = createEventReference(eventId);
    const galleryReference = createGalleryReference(galleryId);
    const teamReference = createTeamReference(teamId);
    const organizationReference = createOrganizationReference(organizationId);

    return {
        id: articleId,
        urlId: articleId,
        reference: articleReference,
        teamId,
        teamReference,
        organizationId,
        organizationReference,
        seasonId,
        seasonReference,
        gameId: '',
        gameReference: null,
        eventId,
        eventReference,
        practiceId: '',
        practiceReference: null,
        playerId: '',
        playerReference: null,
        coachId: '',
        coachReference: null,
        galleryId,
        galleryReference,
        title: createArticleTitleForEvent(demoEventTitle),
        url: demoArticleURL,
        author: demoArticleAuthor,
        tagIds,
        tagReferences,
        tagTypes,
        content: demoArticleContent,
        mobileContent: '',
        sportsType,
        featureImage: demoEventFeatureImage(sportsType),
        notes: demoArticleNotes,
        published: true,
        timeOfArticle: getCurrentDateTime(),
        timeModified: getCurrentDateTime(),
        timeCreated: getCurrentDateTime(),
    };
};
